var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, FlexGrid, Box } from '@telus-uds/components-web';
import { color as Colors } from '@telus-uds/palette-koodo';
import styled from 'styled-components';
import { space } from '../../helpers/theme';
import MarketingCard, { StyledFullHeight } from '../MarketingCard/MarketingCard';
import PageSection from '../PageSection/PageSection';
import RichText from '../RichText/RichText';
export var StackWrapCards = function (_a) {
    var heading = _a.heading, description = _a.description, tiles = _a.tiles, color = _a.color;
    return (_jsx(StyledStackWrapCards, { color: color, children: _jsx(PageSection, { children: _jsxs(Box, { vertical: 7, children: [_jsx(Typography, { block: true, variant: { size: 'h2' }, children: heading }), description && (_jsx(Box, { vertical: 2, children: _jsx(RichText, { content: description }) })), _jsx(StyledCardBody, { children: _jsx(FlexGrid, { gutter: false, children: _jsx(FlexGrid.Row, { children: tiles.map(function (props) { return (_jsx(FlexGrid.Col, { xs: 12, sm: 6, xl: 3, children: _jsx(StyledFullHeight, { children: _jsx(Box, { space: 3, children: _jsx(MarketingCard, __assign({}, props)) }) }) }, props.title)); }) }) }) })] }) }) }));
};
export default StackWrapCards;
// --------------------------- STYLES --------------------------- //
var StyledStackWrapCards = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return Colors[color];
});
var StyledCardBody = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: -", "px;\n  margin-right: -", "px;\n"], ["\n  margin-left: -", "px;\n  margin-right: -", "px;\n"])), space(3), space(3));
var templateObject_1, templateObject_2;
